<template>
  <div v-if="!apiEnable && !isSiteAdmin">
    <h2>Permission Denied</h2>
    <p>You do not have permission to generate web tokens or use the API.</p>
  </div>
  <div v-else>
    <p class="h2-text">Web Token</p>
    <p>
      Here is a web token for this account. Use copy and paste to load it into
      the application you wish to authorize.
    </p>
    <div class="web-token-box">
      <p class="paragraph-text">Your Web Token</p>
      <div class="token-container">
        <textarea
            data-cy="web_token_input"
            v-model="webToken"
            :placeholder="placeholder"
            readonly
            class="web-token custom-textarea"
            rows="4"
        ></textarea>
        <div class="token-actions">
          <EyeIcon data-cy="show_token" title="Show the token" v-if="showEyeIcon" class="eye-icon action-icon" @click="showpopup"/>
          <EyeOffIcon title="Hide the token" v-else class="eye-icon action-icon" @click="hideToken"/>
          <ContentCopyIcon
              title="Copy the token"
              class="action-icon"
              v-bind:class="showEyeIcon ? 'text-muted' : ''"
              @click="copyToken()"
          />
          <div v-if="textCopied" class="token-revoked-popup copy-text">
            <CheckCircleIcon/> &nbsp;Web token copied to clipboard
          </div>
        </div>
      </div>
      <br>
    </div>
    <br/>
    <div class="revoke-token-box">
      <p class="revoke-web-token">Revoke Web Token</p>
      <div v-if="tokenRevokeSuccess" class="token-revoked-popup">
        <CheckCircleIcon/> &nbsp;Web token revoked
      </div>
      <p class="paragraph-text">Enter the token to be revoked:</p>
      <input
          v-model="revokeToken"
          type="text"
          name="revoke"
          autocomplete="off"
          class="custom-imput"
      />
      <br/>
      <button
          class="bbutton revoke-button"
          @click="revokeTokenAction()"
      >
        Revoke
      </button>
    </div>
    <textarea v-model="webToken" class="web-token-clipboard"></textarea>
    <div id="popup" ref="popup" :style="{ display : popupDisplay }">
      <div class="widgettitle">
        <div class="controls">
          <span
              id="puclose"
              class="acclaro-icon ai-close"
              @click="popupclose()"
          ></span>
        </div>
        <b>Password Required</b>
      </div>

      <div class="widgettext">
        <span class="text-muted">Enter your password to continue</span>
        <div class="popup-body">
          <b>Your Password</b>
          <label class="popup-body-label">
            <input
                data-cy="password_required"
                v-model="password"
                @keyup="passwordError = ''"
                placeholder="*************"
                type="password"
                class="password-input"
            />
          </label>
          <label v-if="passwordError.length > 0" class="error-msg">{{
              passwordError
            }}</label>
        </div>
      </div>
      <div class="pupup-button-group">
        <a
            @click="popupclose()"
            class="button sub-action-btn"
        >Cancel</a
        >
        <a
            data-cy="show_token_btn"
            @click="popupSubmitAction()"
            class="button bbutton popup-submit-button"
        >{{ popupOkText }}</a
        >
      </div>
    </div>
  </div>
</template>
<script>

import axios from "axios";
import "./style.scss";
import {
  EyeIcon,
  CheckCircleIcon,
  EyeOffIcon,
  ContentCopyIcon,
} from "../icons.js";

export default {
  components: {
    EyeIcon,
    EyeOffIcon,
    ContentCopyIcon,
    CheckCircleIcon,
  },
  data () {
    return {
      popupDisplay: "none",
      password: "",
      webToken: "",
      revokeToken: "",
      popupOkText: "",
      passwordError: "",
      tokenRevokeSuccess: false,
      textCopied: false,
      popupOption: ''
    };
  },
  props: {
    generateTokenUrl: {
      type: String,
      default: "",
    },
    revokeTokenUrl: {
      type: String,
      default: "",
    },
    apiEnable: {
      type: Number,
      default: 0,
    },
    isSiteAdmin: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    placeholder () {
      return "*".repeat(125);
    },
    showEyeIcon () {
      return this.webToken === '';
    }
  },
  methods: {
    showpopup () {
      this.popupOption = 'generateToken';
      this.popupDisplay = "block";
      this.popupOkText = "Show Token";
      this.password = "";
      this.passwordError = "";
    },
    popupclose () {
      this.popupDisplay = "none";
      this.password = "";
    },
    hideToken () {
      this.webToken = "";
    },
    popupSubmitAction () {
      const password = this.password.trim();
      if (this.popupOption === "revokeToken") {
        if (
            this.revokeToken.length > 0 &&
            this.revokeTokenUrl.length > 0 &&
            password.length > 0
        ) {
          axios
              .post(this.revokeTokenUrl, {
                web_token: this.revokeToken,
                password: password,
              })
              .then((response) => {
                if (response?.data?.success) {
                  this.tokenRevokeSuccess = true;
                  this.revokeToken = "";
                  this.hideToken();
                  this.popupclose();
                  setTimeout(() => {
                    this.tokenRevokeSuccess = false;
                  }, 2000);
                }
                else {
                  this.passwordError = response?.data?.errorMessage;
                }
              }).catch((e) => {
            console.log(e);
          });
        }
      }
      else if (this.popupOption === "generateToken") {
        this.generateToken(password);
      }
    },
    revokeTokenAction () {
      this.popupOption = 'revokeToken';
      this.popupOkText = "Revoke Token";
      this.popupDisplay = "block";
    },
    generateToken (password) {
      if (password.length > 0) {
        axios
            .post(this.generateTokenUrl, { password: password, })
            .then((response) => {
              if (response?.data?.success) {
                this.webToken = response?.data?.web_token;
                this.popupclose();
              }
              else {
                this.passwordError = response?.data?.errorMessage;
              }
            })
            .catch((e) => {
              console.log(e);
            });
      }
    },
    async copyToken() {
        if (!this.webToken) return;
        try {
            await navigator.clipboard.writeText(this.webToken);
            this.textCopied = true;
            setTimeout(() => { this.textCopied = false; }, 2000);
        } catch (e) {
            console.error('Copy failed', e);
        }
    },
  },
};
</script>
